import { asyncFormValidation } from '@/element-ui/form-utils'
import { validateNumber } from '@/element-ui/form-validators'
import { t } from '@/i18n/i18ns'
import _ from 'lodash'

export const convertCommaToPeriod = (value) => {
  if (!_.isEmpty(value)) {
    return value.replace(/,/g, '.')
  }
  return value
}

export default {
  name: 'resolutionCalculatorComponent',
  inject: [
    '$utils'
  ],
  props: {
    resolutionProp: {
      default () { return { height: 0, width: 0 } }
    }
  },
  watch: {
    async resolutionProp (newVal) {
      const formData = this.$utils.clone(this.formData)
      formData.resolution.width = newVal.width
      formData.resolution.height = newVal.height
      this.formData = formData

      if (await this.isFormValid()) {
        this.recalculateSize()
      }
    }
  },
  mixins: [],
  data () {
    return {
      resolution: this.resolutionProp,
      formData: {
        resolution: {
          width: this.resolutionProp.width,
          height: this.resolutionProp.height
        },
        pitch: 1,
        size: {
          height: 0,
          width: 0
        }
      },
      formRules: {
        pitch: [
          {
            validator: validateNumber(t('resolutionCalculator.invalidPitch')), trigger: 'change'
          }
        ],
        'size.width': [
          {
            validator: validateNumber(t('resolutionCalculator.invalidSize')), trigger: 'change'
          }
        ],
        'size.height': [
          {
            validator: validateNumber(t('resolutionCalculator.invalidSize')), trigger: 'change'
          }
        ]
      }
    }
  },
  methods: {
    setDefaultData () {
      this.recalculateSize()
    },
    recalculateResolution () {
      this.formData.resolution = {
        width: Math.round(this.formData.size.width / this.formData.pitch),
        height: Math.round(this.formData.size.height / this.formData.pitch)
      }
    },
    recalculateSize () {
      const width = this.formData.resolution.width * this.formData.pitch
      const height = this.formData.resolution.height * this.formData.pitch

      this.formData.size = {
        width: Number.isInteger(width) ? width : width.toFixed(2),
        height: Number.isInteger(height) ? height : height.toFixed(2)
      }
    },
    async isFormValid () {
      try {
        const isValid = await asyncFormValidation(this.$refs.ledResolutionCalculatorForm)
        return isValid
      } catch (error) {
        return false
      }
    },
    async handleResolutionPitchChange () {
      this.formData.pitch = convertCommaToPeriod(this.formData.pitch)

      if (await this.isFormValid()) {
        this.recalculateSize()
        this.emitEvent()
      }
    },
    async handleWidthHeightChange () {
      this.formData.size.width = convertCommaToPeriod(this.formData.size.width)
      this.formData.size.height = convertCommaToPeriod(this.formData.size.height)

      if (await this.isFormValid()) {
        this.recalculateResolution()
        this.emitEvent()
      }
    },
    emitEvent () {
      this.$emit('resolution-calcultor-change', {
        action: 'APPLY_NEW_CAL_RESOLUTION',
        payload: {
          data: {
            resolution: this.formData.resolution,
            tag: `${this.formData.resolution.width}x${this.formData.resolution.height}`
          }
        }
      })
    }
  },
  mounted () {
    this.setDefaultData()
  }
}
